'use client';

import React from 'react';
import { Button } from 'components/button';
import { useLocale } from 'hooks';
import PropTypes from 'prop-types';

function TypeSelectBox({
  type,
  selected,
  onSelect,
}) {
  const locale = useLocale();
  const translatedType = {
    label: type.label,
  };
  switch (locale) {
    case 'zh-Hant':
      translatedType.label = type.labelChi || translatedType.label;
      break;
    case 'zh-Hans':
      translatedType.label = type.labelSimplifiedChi || translatedType.label;
      break;
  }

  return (
    <Button
      variant="outlined"
      size="large"
      sx={{
        backgroundColor: selected ? 'primary.50' : 'transparent',
        border: selected ? '2px solid #00B4AA' : '1px solid #00B4AA',
        color: 'primary.main',
        borderRadius: '8px',
        '&:hover': {
          backgroundColor: 'primary.50'
        },
        flex: 1,
        width: '100%',
      }}
      onClick={onSelect}
    >
      {translatedType.label}
    </Button>
  );
}

TypeSelectBox.propTypes = {
  type: PropTypes.shape({
    label: PropTypes.string,
    labelChi: PropTypes.string,
    labelSimplifiedChi: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TypeSelectBox;
